import React, { useMemo, useState } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Pagination } from '../components/ui/Pagination';
import { ActionsTable } from '../components/operations/ActionsTable';
import { actionsStore, sortActions } from '../services/actionsStore';
import { Search, Filter, Download } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { usePagination } from '../hooks/usePagination';
export function ActionsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [assigneeFilter, setAssigneeFilter] = useState('all');
  const [refresh, setRefresh] = useState(0);
  const allActions = useMemo(() => actionsStore.getAll(), [refresh]);
  const filteredActions = useMemo(() => {
    let result = allActions;
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      result = result.filter(a => a.name.toLowerCase().includes(lowerSearch) || a.clientName.toLowerCase().includes(lowerSearch) || a.activityProduct.toLowerCase().includes(lowerSearch));
    }
    if (statusFilter !== 'all') {
      const isDone = statusFilter === 'done';
      result = result.filter(a => a.isDone === isDone);
    }
    if (assigneeFilter !== 'all') {
      result = result.filter(a => a.assigneeType === assigneeFilter);
    }
    return sortActions(result);
  }, [allActions, searchTerm, statusFilter, assigneeFilter]);
  const {
    currentPage,
    totalPages,
    paginatedData: currentActions,
    goToPage
  } = usePagination(filteredActions, 15);
  const handleActionUpdate = () => {
    setRefresh(r => r + 1);
  };
  return <Layout data-id="element-1217">
      <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1218">
        <div data-id="element-1219">
          <h1 className="text-2xl font-bold text-seform-navy" data-id="element-1220">Azioni</h1>
          <p className="text-slate-500 mt-1" data-id="element-1221">
            Gestione di tutte le azioni operative
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-1222">
          <Button variant="flat" startContent={<Download className="h-4 w-4" data-id="element-1224" />} data-id="element-1223">
            Esporta
          </Button>
        </div>
      </div>

      <Card noPadding className="mb-6" data-id="element-1225">
        <div className="p-4 border-b border-slate-100 flex flex-col sm:flex-row gap-4" data-id="element-1226">
          <div className="flex-1 relative" data-id="element-1227">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" data-id="element-1228" />
            <input type="text" placeholder="Cerca per azione, cliente o prodotto..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-seform-orange/50 focus:border-seform-orange" data-id="element-1229" />
          </div>
          <div className="flex gap-3" data-id="element-1230">
            <Select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} options={[{
            value: 'all',
            label: 'Tutti gli stati'
          }, {
            value: 'todo',
            label: 'Da fare'
          }, {
            value: 'done',
            label: 'Completate'
          }]} className="w-40" data-id="element-1231" />
            <Select value={assigneeFilter} onChange={e => setAssigneeFilter(e.target.value)} options={[{
            value: 'all',
            label: 'Tutti gli assegnatari'
          }, {
            value: 'consulente',
            label: 'Consulente'
          }, {
            value: 'cliente',
            label: 'Cliente'
          }]} className="w-48" data-id="element-1232" />
          </div>
        </div>

        <ActionsTable actions={currentActions} showClient showResponsible onActionUpdate={handleActionUpdate} data-id="element-1233" />

        {totalPages > 1 && <div className="p-4 border-t border-slate-100 flex justify-end" data-id="element-1234">
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={goToPage} data-id="element-1235" />
          </div>}
      </Card>
    </Layout>;
}